export const tabletWidth = 768;
export const desktopWidth = 992;
export const mobileOnly = `@media (max-width: ${tabletWidth - 1}px)`;
export const tabletOnly = `@media (min-width: ${tabletWidth}px) and (max-width: ${desktopWidth - 1}px)`;
export const tabletAndDown = `@media (max-width: ${desktopWidth - 1}px)`;
export const tabletAndUp = `@media (min-width: ${tabletWidth}px)`;
export const desktopOnly = `@media (min-width: ${desktopWidth}px)`;
